export const STYLE_CONSTANTS = {
    COLORS: {
        DEFAULT: {
            TEXT: '#9D9D9D',
            ICON_FILL: '#9D9D9D',
            HOVER_BG: '#F2E8FF',
            HOVER_FILL: '#6021B3',
            HOVER_TEXT: '#6021B3',
        },
        PENDING: {
            TEXT: '#DF666A',
            ICON_FILL: '#DF666A',
            HOVER_BG: '#ffeeee',
            HOVER_FILL: '#DF666A',
            HOVER_TEXT: '#DF666A',
        },
        RESOLVED: {
            TEXT: '#9d9d9d',
            ICON_FILL: '#CBCBCB',
            HOVER_BG: '#F2E8FF',
            HOVER_FILL: '#6021B3',
            HOVER_TEXT: '#6021B3',
        },
    },
    LABELS: {
        NONE: 'None',
        COMPLETED: 'Completed',
    },
} as const;
